export default "../media/bg_approach_2_large.57f0a7206bfb2d2a99af39946957a4a8.jpeg";